import { Outlet } from 'react-router-dom';
import './App.css';

function App() {
  return (
    <div className=' w-full h-screen bg-[#fafafe] overflow-hidden'>
      <Outlet/>
    </div>
  );
}

export default App;
